import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { authInterceptor } from '@core/auth/auth.interceptor'; // Import functional interceptor
import { provideNuMonacoEditorConfig } from '@ng-util/monaco-editor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // Remove the old HTTP_INTERCEPTORS configuration
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideNuMonacoEditorConfig({
      baseUrl: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min',
    }),
    provideAnimations(),
    provideAnimationsAsync(),
  ],
};
